import { isValidDate } from '@/modules/results/helpers';

interface Timeout {
  start: string;
  result?: string;
  TimeoutStarted?: string;
  TeamOneScore?: number;
  TeamTwoScore?: number;
  TimeoutCalledByUuid?: string;
  ServerWhenTimeoutCalledFullName?: string;
  NextRallyResult?: string;
}

interface MatchTimeoutsProps {
  value1: number | undefined;
  value2: number | undefined;
  text: string;
  timeouts1: Timeout[] | undefined;
  timeouts2: Timeout[] | undefined;
  handleTimeoutsModal: (timeout: Timeout) => void;
}

function MatchTimeouts({
  value1 = 0,
  value2 = 0,
  text = '',
  timeouts1 = [],
  timeouts2 = [],
  handleTimeoutsModal,
}: MatchTimeoutsProps) {
  const isValidString = (str: string) => {
    return (
      typeof str === 'string' &&
      str.trim() !== '' &&
      str !== 'Invalid date' &&
      str !== 'Invalid date CDT'
    );
  };
  return (
    <div className='flex min-h-[110px] flex-wrap border-b py-2 sm:flex-nowrap'>
      <div className='order-2 flex w-1/2 flex-col items-center justify-center p-2 font-bold sm:order-1 sm:w-1/3 sm:p-0'>
        <div>
          <span>{value1}</span>
        </div>
        <ul className='flex flex-col gap-1'>
          {timeouts1.map((item, index: number) => {
            const isValidStart = isValidDate(item.start) || isValidString(item.start);
            return (
              <li
                onClick={() => handleTimeoutsModal(item)}
                key={item.start + index}
                className='flex cursor-pointer flex-col items-center justify-center text-xs font-normal text-experiment'
              >
                <div>{item.result}</div>
                {isValidStart ? <div>{item.start}</div> : null}
              </li>
            );
          })}
        </ul>
      </div>
      <div className='order-1 flex w-full items-center justify-center font-bold sm:order-2 sm:w-1/3'>
        <h5>{text}</h5>
      </div>
      <div className='order-2 flex w-1/2 flex-col items-center justify-center p-2 font-bold sm:order-3 sm:w-1/3 sm:p-0'>
        <div>
          <span>{value2}</span>
        </div>
        <ul className='flex flex-col gap-1'>
          {timeouts2.map((item, index: number) => {
            const isValidStart = isValidDate(item.start) || isValidString(item.start);
            return (
              <li
                onClick={() => handleTimeoutsModal(item)}
                key={item.start + index}
                className='flex cursor-pointer flex-col items-center justify-center text-xs font-normal text-experiment'
              >
                <div>{item.result}</div>
                {isValidStart ? <div>{item.start}</div> : null}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default MatchTimeouts;
